import React from "react";
import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => {
  let styles = {
    root: props => {
      let root = {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.grey[500]
      };

      if (props.fullWidth) {
        root.width = "100%";
      }

      return root;
    }
  };

  return styles;
});

const SecondaryButton = ({
  onClick,
  disabled,
  children,
  fullWidth,
  icon,
  ...props
}) => {
  const classes = useStyles({ fullWidth });

  return (
    <Button
      variant="contained"
      color="secondary"
      classes={classes}
      disabled={disabled}
      startIcon={icon}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;
